import axios from "axios"
import React, { useEffect, useState } from "react"
import Header from "../../../components/navigation/Header"
import Footer from "../../../components/navigation/Footer"
import GetCSFR from "../../../hooks/userAuthentication/GetCSFR"
import LoadingAnimation from "../../../components/general/LoadingAnimation"
import { useNavigate } from "react-router-dom"


export default function Merchandise(){
    const [data,setData] = useState([])
    const csrfToken = GetCSFR({ name: "csrftoken" })
    const navigate = useNavigate()

    // Fetch merchandise catalog
    useEffect(() => {
        document.title = "SkillJa - Merchandise"

        axios.get(`${process.env.REACT_APP_SKILLJA_URL}/merchandise/get_merchandise/`, {
            headers: {
              "X-CSRFToken": csrfToken,
              "Content-Type": "application/json",
            },
            withCredentials: true,
        })
        .then((res) => {
            if (res.status === 200) {
                setData(res.data.data.data)
            }
        })
        .catch((error) => { 
            alert('Error occurred! Please try again later.')
            console.error(error)
        })

    }, [])
    
    return (
        <>
            <Header useCase="merchandise" />
            <section className="flex flex-col justify-center items-center py-2 px-4 lg:px-12 mx-auto mt-10 mb-44">
                <h2 className="text-4xl font-semibold font-source mb-4 text-center">
                    Official SkillJa Merchandise
                </h2>
                <p className=" mb-24 mx-auto px-4 font-kulim text-lg text-center">
                    Support us by repping some SkillJa Merchandise. Free shipping on all orders!
                </p>
                <div className={`mx-auto w-full ${data.length > 0 && 'grid grid-cols-1 md:grid-cols-3 gap-6'}`}>
                    {data.length === 0 ? 
                        <div className="my-20 mx-auto">
                            <LoadingAnimation />
                        </div>
                        
                    :
                        data.map((item: any) => (
                            <article 
                                key={item.id} 
                                className="border border-main-grey-100 bg-white rounded-lg p-6 font-kulim cursor-pointer m-auto hover:border-main-green-500"
                                onClick={()=>navigate(`./${item.id}`)}
                                tabIndex={0}
                            >
                                <img 
                                    src={item.images?.[0]?.src} 
                                    alt={item.title} 
                                    className="w-full h-auto rounded-md max-w-md"
                                />
                                <h3 className="text-xl font-semibold mt-2">{item.title}</h3>
                                <p className="text-lg font-medium mt-1">
                                    ${item.variants?.[0]?.price / 100}
                                </p>
                                <button className="mt-6 bg-main-green-500 hover:bg-main-green-700 text-white py-2 px-4 rounded-md">
                                    Buy Now
                                </button>
                            </article>
                        ))}
                </div>
            </section>
            <Footer />
        </>
    )
}